import {Component, OnInit, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../services/auth2.service";
import {ApiService} from "../../../services/api.service";
import {SearchService} from "../services/search.service";
import {HttpErrorResponse} from "@angular/common/http";
import {SearchIDsCriteriaDto} from "../../../models/search-ids-criteria-dto";
import {UserService} from "../../users/services/users.service";
import {saveAs} from "file-saver";
import {StPagination2Component} from "../../../shared-components/ui-components/st-pagination/st-pagination2.component";
import {PageChangeDto} from "../../../models/page-change-dto";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {DonorNamesCacheService} from "../../dropdown-cache-services/donor-names-cache.service";
import {KeyStaffDropdownCacheService} from "../../dropdown-cache-services/key-staff-dropdown-cache.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-search-donors-page',
  templateUrl: './search-donors-page.component.html',
  styleUrls: ['./search-donors-page.component.scss'],
  standalone: false
})
export class SearchDonorsPageComponent extends LoggedInPageBaseComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Search Donors'}
  ];

  protected readonly event = event;
  pageName: string = 'Search Donors';
  platform: string = '';
  isSideNavOpened: boolean = false;
  loadingIcon = false;

  errorMessages: any[] = [];
  successMessages: any[] = [];

  savedSearchArray: any[] = [];
  currentSavedSearchDto: any;
  searchTypeNameMap: any = {};

  rows: any[] = [];

  names: string[] = [];
  namesWithout: string[] = [];
  eins: string[] = [];
  includeTaxExemptRevoked: boolean = false;
  minYearsInBusiness: number = 0;
  states: string[] = [];
  cities: string[] = [];//will only be one
  citiesWithout: string[] = [];//will only be one
  zipCodes: string[] = [];//will only be one
  counties: string[] = [];
  countiesWithout: string[] = [];
  affiliationCodeIds: number[] = [];
  deductabilityCodeIds: number[] = [];
  eoClassificationCodes: string[] = [];
  eoSubsectionCodes: string[] = [];
  filingReqCodeIds: number[] = [];
  pfFilingReqCodeIds: number[] = [];
  foundationCodeIds: number[] = [];
  nteeCodeIds: number[] = [];
  nteeParentCodeIds: number[] = [];
  organizationCodeIds: number[] = [];
  returnTypeCodeIds: number[] = [];
  totalAssetsRange: number[] = [];// will always be just one if selected but the end result is 2 (a min and a max)
  totalIncomeRange: number[] = [];
  causes: string[] = [];
  keyStaff: string[] = [];// will always be just one
  donatedGrantsCities: string[] = [];
  donatedGrantsStates: string[] = [];
  taxYear: number = 0;

  statesList: any[] = [];
  citiesCheckboxes: any[] = [];
  affiliationCodeCheckboxes: any[] = [];
  affiliationCodeButton: boolean = false;

  deductabilityCodeCheckboxes: any[] = [];
  deductabilityCodeButton: boolean = false;

  eoSubsectionClassificationCodeCheckboxes: any[] = [];
  eoSubsectionClassificationCodeButton: boolean = false;

  filingReqCodeCheckboxes: any[] = [];
  filingReqCodeButton: boolean = false;

  pfFilingReqCodeCheckboxes: any[] = [];
  pfFilingReqCodeButton: boolean = false;

  foundationCodeCheckboxes: any[] = [];
  foundationCodeButton: boolean = false;

  nteeCodeCheckboxes: any[] = [];
  nteeCodeButton: boolean = false;

  nteeParentCodeCheckboxes: any[] = [];
  nteeParentCodeButton: boolean = false;

  organizationCodeCheckboxes: any[] = [];
  organizationCodeButton: boolean = false;

  returnTypeCodeCheckboxes: any[] = [];
  returnTypeCodeButton: boolean = false;

  totalAssetsRadioButtons: any[] = [];
  totalAssetsButton: boolean = false;

  totalIncomeRadioButtons: any[] = [];
  totalIncomeButton: boolean = false;

  advancedFiltersButton: boolean = false;

  causeDropdownList: any[] = [];
  causeGivingInterestsObj: any = {};
  causeGivingInterestsDropdownList: any[] = [];

  taxYears: any[] = [
    {"taxYear": 2025},{"taxYear": 2024}, {"taxYear": 2023}, {"taxYear": 2022}, {"taxYear": 2021}, {"taxYear": 2020}
  ]

  givingInterestsSetObj: any = {};
  givingInterestsWithoutSetObj: any = {};
  causeGivingInterestsList: string[] = [];
  causeGivingInterestsWithoutList: string[] = [];

  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  emailCodeVerifiedFlag: string = 'N';
  subscriptionActive: boolean = false;
  pilotTrialVerified: boolean = false;
  customerTrialVerified: boolean = false;

  savedSearchModal: any = null;
  savedSearchOpenModalBtn1: HTMLElement | null = null;
  savedSearchOpenModalBtn2: HTMLElement | null = null;
  savedSearchCloseSpan: HTMLElement | null = null;

  cityDonorStats: any[] = [];
  cityDonorTopStats: any[] = [];

  logicalOperatorAnd: boolean = false;
  logicalOperatorOr: boolean = true;

  sortByCompanyNameAscId: number = 0;
  sortByCityAscId: number = 0;
  sortByStateAscId: number = 0;
  sortByTotalAssetsAscId: number = 0;
  companyNameAscRadioButton: boolean = false;
  companyNameDescRadioButton: boolean = false;
  cityAscRadioButton: boolean = false;
  cityDescRadioButton: boolean = false;
  stateAscRadioButton: boolean = false;
  stateDescRadioButton: boolean = false;
  totalAssetsAscRadioButton: boolean = false;
  totalAssetsDescRadioButton: boolean = false;

  sortedAscCompanyNameHeaderButton: boolean = false;
  sortedAscCityHeaderButton: boolean = false;
  sortedAscStateHeaderButton: boolean = false;
  sortedAscTotalAssetsHeaderButton: boolean = false;

  @ViewChild('donorspaginator') stPaginator2Component!: StPagination2Component;
  page: number = 1;
  pageSize: number = 100;
  collectionSize: number = 0;
  customPageSizes = [
    {
      "pageSizeId" : 50,
      "pageSize": 50
    }, {
      "pageSizeId" : 100,
      "pageSize": 100
    }, {
      "pageSizeId" : 250,
      "pageSize": 250
    }, {
      "pageSizeId" : 500,
      "pageSize": 500
    }
  ];

  showSideNavErrorMessages: boolean = false;
  sideNavErrorMessages: any[] = [];
  showSideNavSuccessMessages: boolean = false;
  sideNavSuccessMessages: any[] = [];

  //citiesAutocomplete: any[] = [{city: "ABBEVILLE:AL", state: "AL"}, {city: "AUSTIN:TX", state: "TX"}];
  citiesAutocomplete: any[] = [];
  companyNamesAutocomplete: any[] = [];
  keyStaffAutocomplete: any[] = [];

  //Needs pop up for Donor Limit on creation
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private searchService: SearchService,
              private userService: UserService, private routerChild: Router,
              private donorNamesCacheService : DonorNamesCacheService,
              private keyStaffDropdownCacheService : KeyStaffDropdownCacheService,
              private titleService: Title
              ) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Search Donors")
  }

  ngOnInit(): void {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.emailCodeVerifiedFlag = this.auth2ServiceChild.getEmailCodeVerifiedFlag();
    if (this.emailCodeVerifiedFlag != 'Y') {
      this.routerChild.navigateByUrl('app/users/emails/verify')
      return;
    } else {
      this.userService.getSubscriptionVerification(this.username).subscribe(
        (verificationResult: any) => {
          this.subscriptionActive = verificationResult.body.verified;
          this.pilotTrialVerified = verificationResult.body.pilotTrialVerified;
          this.customerTrialVerified = verificationResult.body.customerTrialVerified;

          //Begin initializing page
          this.populateFilters();
          const delayedSetup = () => {
            this.setUpSavedSearchModal();
            const lastSearchJsonString = localStorage.getItem('lastSearchDonor');
            if (lastSearchJsonString) {
              // @ts-ignore
              const lastSearchFilter: any = JSON.parse(lastSearchJsonString);
              this.loadDonorLastSearchParams(lastSearchFilter);
            }
          }
          setTimeout(delayedSetup, 4000);
          this.platform = navigator.userAgent;
          if (this.platform) {
            this.platform = this.platform.toLowerCase();
            console.log('platform: ' + this.platform)
          }
        }, (error:HttpErrorResponse) => {
          this.redirectToLogin(error);
          this.pageErrorMessages.push({
            field: 'Subscription Error',
            detail: 'This feature is not available for inactive subscriptions. Please activate your subscription.',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
      );
    }
  }
  openSavedSearchModal(): boolean {
    this.closeNav();
    // @ts-ignore
    this.savedSearchModal.style.display = "block";
    return true;
  }
  closeSavedSearchModal(): boolean {
    // @ts-ignore
    this.savedSearchModal.style.display = "none";
    return true;
  }

  setUpSavedSearchModal(): void {
    // Get the modal
    this.savedSearchModal = document.getElementById("saved-search-modal-id");

    // Get the button that opens the modal
    // @ts-ignore
    this.savedSearchOpenModalBtn1 = document.getElementById("saved-search-modal-button1-id");
    this.savedSearchOpenModalBtn2 = document.getElementById("saved-search-modal-button2-id");
    // Get the <span> element that closes the modal
    this.savedSearchCloseSpan = document.getElementsByClassName("close")[0] as HTMLElement;
  }

  showSideNavErrorMessagesToUser(): void {
    this.showSideNavErrorMessages = true;
    const counterFn = () => {
      this.showSideNavErrorMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  showSideNavSuccessMessagesToUser(): void {
    this.showSideNavSuccessMessages = true;
    const counterFn = () => {
      this.showSideNavSuccessMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  populateDonorCities(): void {
    // @ts-ignore
    let donorCitiesCacheExpTimeStr: string = localStorage.getItem('donorCitiesCacheExpTime');
    if (!donorCitiesCacheExpTimeStr) {
      //expire the cached search
      localStorage.removeItem('donorCitiesCache');
    } else {
      let donorCitiesExpTime: number = parseInt(donorCitiesCacheExpTimeStr);
      let now = Date.now();
      if (now >= donorCitiesExpTime) {
        //expire the cached search
        localStorage.removeItem('donorCitiesCache');
      }
    }
    const donorCitiesCacheJsonString = localStorage.getItem('donorCitiesCache');
    if (!donorCitiesCacheJsonString) {
      this.searchService.getDonorsCities(this.username).subscribe((result: any) => {
        if (result && result.body) {
          let i: number = 0;
          while (i < result.body.size) {
            this.citiesAutocomplete.push(result.body.citiesStates[i]);
            i = i + 1;
          }
          let expirationTimestamp: number = Date.now() + 1000*3600*8;
          localStorage.setItem('donorCitiesCacheExpTime', expirationTimestamp.toString());
          localStorage.setItem('donorCitiesCache', JSON.stringify(this.citiesAutocomplete));
        }
      }, (error: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Search Donors Error',
          detail: 'Failed to pull Donor cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      })
    } else {
      this.citiesAutocomplete = JSON.parse(donorCitiesCacheJsonString);
    }
  }

  populateDonorCompanyNames(): void {
    this.searchService.getDonorsCompanyNames(this.username).subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.companyNamesAutocomplete.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Search Donors Error',
        detail: 'Failed to pull Donor company names.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  populateDonorKeyStaffFromCache(): void {
    this.keyStaffAutocomplete = this.keyStaffDropdownCacheService.getCache();
  }
  populateDonorKeyStaff(): void {
    this.searchService.getDonorsKeyStaff(this.username).subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.keyStaffAutocomplete.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Search Donors Error',
        detail: 'Failed to pull Donor KeyStaff.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  populateFilters(): void {
    this.populateUSAStates();
    this.populateDonorCities();
    this.populateDonorCompanyNames();
    this.populateDonorKeyStaff();
    //this.populateDonorKeyStaffFromCache();
    //this.populateAffiliationCodeCheckboxes();
    //this.populateDeductabilityCodeCheckboxes();
    //this.populateEoClassificationSubsectionCodeCheckboxes();
    this.populateFoundationCodeCheckboxes();
    this.populateFilingReqCodeCheckboxes();
    this.populatePfFilingReqCodeCheckboxes();
    this.populateNteeCodeCheckboxes();
    this.populateNteeParentCodeCheckboxes();
    this.populateOrganizationCodeCheckboxes();
    this.populateReturnTypeCodeCheckboxes();
    this.populateTotalAssetsRangeRadioButtons();
    this.populateTotalIncomeRangeRadioButtons();
    this.populateCauseCategories();
    //this.populateCauseGivingInterestsDropdown();

    this.populateResultsFromLastSearch();
    this.getSavedSearches();
    this.loadSearchTypeNameMap();
  }

  getSavedSearches(): void {
    this.userService.getAllSavedSearches(this.username, 'DONOR_SEARCH', this.impersonatedEmail)
      .subscribe(
        (result: any) => {
          if (result && result.body) {
            this.savedSearchArray = result.body;
          }
        }, (err: HttpErrorResponse) => {
          this.pageErrorMessages.push({
            field: 'Saved Search API Error',
            detail: 'Failed to pull the saved searches...',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
    )
  }
  changePageResults(pageChangeDto: PageChangeDto): void {
    let updatePageValue: number = 0
    if (pageChangeDto) {
      updatePageValue = pageChangeDto["page"];
      this.pageSize = pageChangeDto["pageSize"]
    }
    this.loadingIcon = true;
    // @ts-ignore
    let filter: string = localStorage.getItem('lastSearchDonor');
    const lastSearchFilter: any = JSON.parse(filter);

    this.searchService.getDonorsPages(lastSearchFilter, updatePageValue, this.pageSize, this.username)
      .subscribe((result : any) => {
        if (result && result.body) {
          this.rows = result.body.dtos;
          this.page = updatePageValue
          this.collectionSize = result.body.collectionSize
        }
        this.loadingIcon = false;
      }, (err: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Search Donor Error',
          detail: 'Failed to pull the donors. Please try again.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.loadingIcon = false;
      })
  }

  populateResultsFromLastSearch(newSort: boolean = false): void {
    // @ts-ignore
    let lastSearchDonorExpTimeStr: string = localStorage.getItem('lastSearchDonorExpTime');
    if (!lastSearchDonorExpTimeStr) {
      //expire the cached search
      localStorage.removeItem('lastSearchDonor');
    } else {
      let lastSearchDonorExpTime: number = parseInt(lastSearchDonorExpTimeStr);
      let now = Date.now();
      if (now >= lastSearchDonorExpTime) {
        //expire the cached search
        localStorage.removeItem('lastSearchDonor');
      }
    }
    const lastSearchJsonString = localStorage.getItem('lastSearchDonor');
    if (lastSearchJsonString) {
      // @ts-ignore
      const lastSearchFilter: any = JSON.parse(lastSearchJsonString);
      if (newSort) {
        this.page = 1;
        this.sortByCompanyNameAscId = 0;
        if (this.companyNameAscRadioButton) {
          this.sortByCompanyNameAscId = 1;
        } else if (this.companyNameDescRadioButton) {
          this.sortByCompanyNameAscId = 2;
        }

        this.sortByCityAscId = 0;
        if (this.cityAscRadioButton) {
          this.sortByCityAscId = 1;
        } else if (this.cityDescRadioButton) {
          this.sortByCityAscId = 2;
        }

        this.sortByStateAscId = 0;
        if (this.stateAscRadioButton) {
          this.sortByStateAscId = 1;
        } else if (this.stateDescRadioButton) {
          this.sortByStateAscId = 2;
        }

        this.sortByTotalAssetsAscId = 0;
        if (this.totalAssetsAscRadioButton) {
          this.sortByTotalAssetsAscId = 1;
        } else if (this.totalAssetsDescRadioButton) {
          this.sortByTotalAssetsAscId = 2;
        }
        lastSearchFilter['sortByCompanyNameAsc'] = this.sortByCompanyNameAscId;
        lastSearchFilter['sortByCityAsc'] = this.sortByCityAscId;
        lastSearchFilter['sortByStateAsc'] = this.sortByStateAscId;
        lastSearchFilter['sortByTotalAssetsAsc'] = this.sortByTotalAssetsAscId
      }
      localStorage.setItem('lastSearchDonor', JSON.stringify(lastSearchFilter));
      // @ts-ignore
      this.executeSearchPages(lastSearchFilter, this.page, this.pageSize, this.username);
    }
  }

  computeCityDonorStats(): void {
    const donorSetObj: any = {};
    this.cityDonorStats = [];
    this.cityDonorTopStats = [];
    // Summarize the cities
    for (const donorRow of this.rows) {
      const cityStateKey: string =  donorRow.city + ', ' + donorRow.state;
      if (!donorSetObj[cityStateKey]) {
        donorSetObj[cityStateKey] = 1;
      } else {
        donorSetObj[cityStateKey] = donorSetObj[cityStateKey] + 1
      }
    }

    for (const cityStateKey in donorSetObj) {
      this.cityDonorStats.push(
        {'city': cityStateKey, 'numberOfDonors' : donorSetObj[cityStateKey]});
    }
    this.cityDonorStats = this.apiService.sortTextDesc('numberOfDonors', this.cityDonorStats);

    const topCount: number = 5
    let i: number = 0;
    while (i < this.cityDonorStats.length) {
      if (i >= topCount) {
        break;
      }
      this.cityDonorTopStats.push(this.cityDonorStats[i]);
      i = i + 1;
    }
  }

  loadDonorLastSearchParams(donorSearchJson: any): void {
    if (donorSearchJson['names'] && donorSearchJson['names'].length > 0) {
      const namesEl = document.getElementById('name-with-text-id');
      // @ts-ignore
      namesEl.value = donorSearchJson['names'].join(',');
    }
    /*
    if (donorSearchJson['namesWithout'] && donorSearchJson['namesWithout'].length > 0) {
      const namesWithoutEl = document.getElementById('name-without-text-id');
      // @ts-ignore
      namesWithoutEl.value = donorSearchJson['namesWithout'].join(',');
    }*/

    if (donorSearchJson['eins'] && donorSearchJson['eins'].length > 0) {
      const einsEl = document.getElementById('ein-text-id');
      // @ts-ignore
      einsEl.value = donorSearchJson['eins'].join(',');
    }

    if (donorSearchJson['taxYear']) {
      const taxYearEl = document.getElementById('tax-year-dropdown-list-id');
      // @ts-ignore
      taxYearEl.value = donorSearchJson['taxYear'];// already number
    }

    if (donorSearchJson['donatedGrantsCities'] && donorSearchJson['donatedGrantsCities'].length > 0) {
      const citiesEl = document.getElementById('donated-grants-cities-text-id');
      // @ts-ignore
      citiesEl.value = donorSearchJson['donatedGrantsCities'].join(',');
    }
    if (donorSearchJson['donatedGrantsStates'] && donorSearchJson['donatedGrantsStates'].length > 0) {
      const donatedGrantsUsaStatesEl = document.getElementById('dg-usa-dropdown-list-id');
      const state: string = donorSearchJson['donatedGrantsStates'][0]
      // @ts-ignore
      donatedGrantsUsaStatesEl.value = state;
    }

    if (donorSearchJson['cities'] && donorSearchJson['cities'].length > 0) {
      const citiesEl = document.getElementById('cities-text-id');
      // @ts-ignore
      citiesEl.value = donorSearchJson['cities'].join(',');
    }
    /*
    if (donorSearchJson['citiesWithout'] && donorSearchJson['citiesWithout'].length > 0) {
      const citiesWithoutEl = document.getElementById('cities-without-text-id');
      // @ts-ignore
      citiesWithoutEl.value = donorSearchJson['citiesWithout'].join(',');
    }*/
    if (donorSearchJson['zipCodes'] && donorSearchJson['zipCodes'].length > 0) {
      const zipCodesEl = document.getElementById('zip-code-text-id');
      // @ts-ignore
      zipCodesEl.value = donorSearchJson['zipCodes'][0];
    }
    /*
    if (donorSearchJson['counties'] && donorSearchJson['counties'].length > 0) {
      this.donor_countiesInput = donorSearchJson['counties'][0];
    }
    if (donorSearchJson['countiesWithout'] && donorSearchJson['countiesWithout'].length > 0) {
      this.donor_countiesWithoutInput = donorSearchJson['countiesWithout'][0];
    }*/

    if (donorSearchJson['keyStaff'] && donorSearchJson['keyStaff'].length > 0) {
      const keyStaffEl = document.getElementById('key-staff-text-id');
      // @ts-ignore
      keyStaffEl.value = donorSearchJson['keyStaff'][0];
    }
    if (donorSearchJson['filingReqCodeIds'] && donorSearchJson['filingReqCodeIds'].length > 0) {
      for (const filingReqCodeId of donorSearchJson['filingReqCodeIds']) {
        let i: number = 0;
        let filingReqCodeLength: number = this.filingReqCodeCheckboxes.length;
        while (i < filingReqCodeLength) {
          if (this.filingReqCodeCheckboxes[i].filingReqCodeId === filingReqCodeId) {
            this.filingReqCodeCheckboxes[i].checked = true;
            this.filingReqCodeButton = true;
          }
          i = i + 1;
        }
      }
      this.advancedFiltersButton = true;
    }

    if (donorSearchJson['foundationCodeIds'] && donorSearchJson['foundationCodeIds'].length > 0) {
      for (const foundationCodeId of donorSearchJson['foundationCodeIds']) {
        let i: number = 0;
        let foundationCodeLength: number = this.foundationCodeCheckboxes.length;
        while (i < foundationCodeLength) {
          if (this.foundationCodeCheckboxes[i].foundationCodeId === foundationCodeId) {
            this.foundationCodeCheckboxes[i].checked = true;
            this.foundationCodeButton = true;
          }
          i = i + 1;
        }
      }
      this.advancedFiltersButton = true;
    }

    if (donorSearchJson['nteeCodeIds'] && donorSearchJson['nteeCodeIds'].length > 0) {
      for (const nteeCodeId of donorSearchJson['nteeCodeIds']) {
        let i: number = 0;
        let nteeCodeLength: number = this.nteeCodeCheckboxes.length;
        while (i < nteeCodeLength) {
          if (this.nteeCodeCheckboxes[i].nteeCodeId === nteeCodeId) {
            this.nteeCodeCheckboxes[i].checked = true;
            this.nteeCodeButton = true;
          }
          i = i + 1;
        }
      }
      this.advancedFiltersButton = true;
    }

    if (donorSearchJson['nteeParentCodeIds'] && donorSearchJson['nteeParentCodeIds'].length > 0) {
      for (const nteeParentCodeId of donorSearchJson['nteeParentCodeIds']) {
        let i: number = 0;
        let nteeParentCodeLength: number = this.nteeParentCodeCheckboxes.length;
        while (i < nteeParentCodeLength) {
          if (this.nteeParentCodeCheckboxes[i].nteeParentCodeId === nteeParentCodeId) {
            this.nteeParentCodeCheckboxes[i].checked = true;
            this.nteeParentCodeButton = true;
          }
          i = i + 1;
        }
      }
      this.advancedFiltersButton = true;
    }

    if (donorSearchJson['organizationCodeIds'] && donorSearchJson['organizationCodeIds'].length > 0) {
      for (const organizationCodeId of donorSearchJson['organizationCodeIds']) {
        let i: number = 0;
        let organizationCodeLength: number = this.organizationCodeCheckboxes.length;
        while (i < organizationCodeLength) {
          if (this.organizationCodeCheckboxes[i].organizationCodeId === organizationCodeId) {
            this.organizationCodeCheckboxes[i].checked = true;
            this.organizationCodeButton = true;
          }
          i = i + 1;
        }
      }
      this.advancedFiltersButton = true;
    }

    if (donorSearchJson['returnTypeCodeIds'] && donorSearchJson['returnTypeCodeIds'].length > 0) {
      for (const returnTypeCodeId of donorSearchJson['returnTypeCodeIds']) {
        let i: number = 0;
        let returnTypeCodeLength: number = this.returnTypeCodeCheckboxes.length;
        while (i < returnTypeCodeLength) {
          if (this.returnTypeCodeCheckboxes[i].returnTypeCodeId === returnTypeCodeId) {
            this.returnTypeCodeCheckboxes[i].checked = true;
            this.returnTypeCodeButton = true;
          }
          i = i + 1;
        }
      }
    }

    if (donorSearchJson['totalAssetsRange'] && donorSearchJson['totalAssetsRange'].length > 0) {
      for (const assetRangeObj of this.totalAssetsRadioButtons) {
        let i: number = 0;
        if (assetRangeObj.minTotalAssets === donorSearchJson['totalAssetsRange'][0]
          && assetRangeObj.maxTotalAssets === donorSearchJson['totalAssetsRange'][1]) {
          assetRangeObj.checked = true;
          this.totalAssetsButton = true;
          break;
        }
      }
      this.advancedFiltersButton = true;
    }

    if (donorSearchJson['totalIncomeRange'] && donorSearchJson['totalIncomeRange'].length > 0) {
      for (const incomeRangeObj of this.totalIncomeRadioButtons) {
        let i: number = 0;
        if (incomeRangeObj.minTotalIncome === donorSearchJson['totalIncomeRange'][0]
          && incomeRangeObj.maxTotalIncome === donorSearchJson['totalIncomeRange'][1]) {
          incomeRangeObj.checked = true;
          this.totalIncomeButton = true;
          break;
        }
      }
      this.advancedFiltersButton = true;
    }

    this.causeGivingInterestsList = [];
    if (donorSearchJson['causeGivingInterests'] && donorSearchJson['causeGivingInterests'].length > 0) {
      for (const causeGivingInterest of donorSearchJson['causeGivingInterests']) {
        this.causeGivingInterestsList.push(causeGivingInterest);
      }
    }

    this.causeGivingInterestsWithoutList = [];
    /*
    if (donorSearchJson['causeGivingInterestsWithout'] && donorSearchJson['causeGivingInterestsWithout'].length > 0) {
      for (const causeGivingInterest of donorSearchJson['causeGivingInterestsWithout']) {
        this.causeGivingInterestsWithoutList.push(causeGivingInterest);
      }
    }*/

    if (donorSearchJson['sortByCompanyNameAsc']) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      if (donorSearchJson['sortByCompanyNameAsc'] == 1) {
        this.companyNameAscRadioButton = true;
      } else if (donorSearchJson['sortByCompanyNameAsc'] == 2) {
        this.companyNameDescRadioButton = true;
      }
    }

    this.cityAscRadioButton = false;
    this.cityDescRadioButton = false;
    if (donorSearchJson['sortByCityAsc']) {
      if (donorSearchJson['sortByCityAsc'] == 1) {
        this.cityAscRadioButton = true;
      } else if (donorSearchJson['sortByCityAsc'] == 2) {
        this.cityDescRadioButton = true;
      }
    }

    this.stateAscRadioButton = false;
    this.stateDescRadioButton = false;
    if (donorSearchJson['sortByStateAsc']) {
      if (donorSearchJson['sortByStateAsc'] == 1) {
        this.stateAscRadioButton = true;
      } else if (donorSearchJson['sortByStateAsc'] == 2) {
        this.stateDescRadioButton = true;
      }
    }

    this.totalAssetsAscRadioButton = false;
    this.totalAssetsDescRadioButton = false;
    if (donorSearchJson['sortByTotalAssetsAsc']) {
      if (donorSearchJson['sortByTotalAssetsAsc'] == 1) {
        this.totalAssetsAscRadioButton = true;
      } else if (donorSearchJson['sortByTotalAssetsAsc'] == 2) {
        this.totalAssetsDescRadioButton = true;
      }
    }

    if (donorSearchJson['states'] && donorSearchJson['states'].length > 0) {
      const usaStatesEl = document.getElementById('usa-dropdown-list-id');
      // @ts-ignore
      usaStatesEl.value = donorSearchJson['states'][0];
    }
  }

  resetAllFiltersModal(): boolean {
    this.loadingIcon = false;
    this.showErrorMessages = false;
    this.errorMessages = [];
    this.showSuccessMessages = false;
    this.successMessages = [];
    //Build search dto from checkboxes
    let nonEmptyFilterFlag : boolean = false;
    this.names = [];
    const nameEl = document.getElementById('name-with-text-id');
    // @ts-ignore
    nameEl.value = '';

    this.namesWithout = [];
    //const nameWithoutEl = document.getElementById('name-without-text-id');
    // @ts-ignore
    //nameWithoutEl.value = '';

    this.eins = [];
    const einsEl = document.getElementById('ein-text-id');
    // @ts-ignore
    einsEl.value = '';

    this.states = [];
    const usaStatesEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    usaStatesEl.value = '';

    this.cities = [];
    const cityEl = document.getElementById('cities-text-id');
    // @ts-ignore
    cityEl.value = '';
    this.taxYear = 0;
    this.donatedGrantsCities = [];
    this.donatedGrantsStates = [];

    const dgUsaStatesEl = document.getElementById('dg-usa-dropdown-list-id');
    // @ts-ignore
    dgUsaStatesEl.value = '';


    const donatedGrantsCitiesEl = document.getElementById('donated-grants-cities-text-id');
    // @ts-ignore
    donatedGrantsCitiesEl.value = '';


    const taxYearEl = document.getElementById('tax-year-dropdown-list-id');
    // @ts-ignore
    taxYearEl.value = '';

    this.citiesWithout = [];
    //const cityWithoutEl = document.getElementById('cities-without-text-id');
    // @ts-ignore
    //cityWithoutEl.value = '';

    this.zipCodes = [];
    const zipCodesEl = document.getElementById('zip-code-text-id');
    // @ts-ignore
    zipCodesEl.value = '';

    this.counties = [];
    /*
    const countyEl = document.getElementById('counties-text-id');
    // @ts-ignore
    countyEl.value = '';*/

    this.countiesWithout = [];
    /*
    const countyWithoutEl = document.getElementById('counties-without-text-id');
    // @ts-ignore
    countyWithoutEl.value = '';*/

    this.affiliationCodeIds = [];
    for (const affiliationCodeCheckboxTemp of this.affiliationCodeCheckboxes) {
      affiliationCodeCheckboxTemp.checked = false;
    }

    this.deductabilityCodeIds = [];
    for (const deductabilityCodeCheckboxTemp of this.deductabilityCodeCheckboxes) {
      deductabilityCodeCheckboxTemp.checked = false;
    }

    this.eoClassificationCodes = [];
    this.eoSubsectionCodes = [];

    this.filingReqCodeIds = [];
    for (const filingReqCodeCheckboxTemp of this.filingReqCodeCheckboxes) {
      filingReqCodeCheckboxTemp.checked = false;
    }

    this.foundationCodeIds = [];
    for (const foundationCodeCheckboxTemp of this.foundationCodeCheckboxes) {
      foundationCodeCheckboxTemp.checked = false;
    }

    this.nteeCodeIds = [];
    for (const nteeCodeCheckboxTemp of this.nteeCodeCheckboxes) {
      nteeCodeCheckboxTemp.checked = false;
    }

    this.nteeParentCodeIds = [];
    for (const nteeParentCodeCheckboxTemp of this.nteeParentCodeCheckboxes) {
      nteeParentCodeCheckboxTemp.checked = false;
    }

    this.organizationCodeIds = [];
    for (const organizationCodeCheckboxTemp of this.organizationCodeCheckboxes) {
      organizationCodeCheckboxTemp.checked = false;
    }

    //Time Varying Parameters
    //Total Assets Range
    this.totalAssetsRange = [];
    for (const totalAssetsRadioButtonTemp of this.totalAssetsRadioButtons) {
      totalAssetsRadioButtonTemp.checked = false;
    }

    this.totalIncomeRange = [];
    for (const totalIncomeRadioButtonTemp of this.totalIncomeRadioButtons) {
      totalIncomeRadioButtonTemp.checked = false;
    }
    this.minYearsInBusiness = 0;
    this.includeTaxExemptRevoked = false;

    this.causes = [];

    //Key Employees
    this.keyStaff = [];
    const keyStaffEl = document.getElementById('key-staff-text-id');
    // @ts-ignore
    keyStaffEl.value = '';

    const causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    causeCategorySel.value = '';

    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    causeGivingInterestEl.value = '';

    //Giving Interests build list
    this.causeGivingInterestsList = [];
    this.givingInterestsSetObj = {};

    //Giving Interests Without build list
    this.causeGivingInterestsWithoutList = [];
    this.givingInterestsWithoutSetObj = {}

    this.sortByCompanyNameAscId = 0;
    this.sortByCityAscId = 0;
    this.sortByStateAscId = 0;
    this.sortByTotalAssetsAscId = 0;
    this.companyNameAscRadioButton = false;
    this.companyNameDescRadioButton = false;
    this.cityAscRadioButton = false;
    this.cityDescRadioButton = false;
    this.stateAscRadioButton = false;
    this.stateDescRadioButton = false;
    this.totalAssetsAscRadioButton = false;
    this.totalAssetsDescRadioButton = false;

    this.sortedAscCompanyNameHeaderButton = false;
    this.sortedAscCityHeaderButton = false;
    this.sortedAscStateHeaderButton = false;
    this.sortedAscTotalAssetsHeaderButton = false;
    return true;
  }

  clearResultsAndFilter(): boolean {
    this.resetAllFiltersModal();
    this.collectionSize = 0;
    this.page = 1;
    this.rows = [];
    this.stPaginator2Component.initPages(this.collectionSize, this.pageSize);
    localStorage.removeItem('lastSearchDonor');
    localStorage.removeItem('lastSearchDonorExpTime');
    return true;
  }

  executeSearchPages(filter: any, page: number, pageSize: number, username: string): void {
    this.loadingIcon = true;
    this.closeNav();
    this.searchService.getDonorsPages(filter, page, pageSize, username).subscribe((result: any) => {
      if (result && result.body) {
        //populate table with results
        this.collectionSize = result.body.collectionSize;
        this.page = result.body.page;
        this.pageSize = result.body.pageSize;
        this.rows = result.body.dtos;
        this.stPaginator2Component.initPages(this.collectionSize, this.pageSize);
        //this.computeCityDonorStats();
      }
      this.loadingIcon = false;
      //this.closeNav();
    }, (err: HttpErrorResponse) => {
      this.redirectToLogin(err);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull the donors. Please try again.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.loadingIcon = false;
    });
  }

  onSelectSavedSearch(event: Event): void {
    let savedSearchEl = document.getElementById("saved-search-selector-id");
    // @ts-ignore
    let savedSearchId: number = savedSearchEl.value;
    let i: number = 0;
    for (const savedSearchObj of this.savedSearchArray) {
      if (savedSearchObj.savedSearchId === savedSearchId) {
        break;
      }
      i = i + 1;
    }
    this.executeSearchPages(JSON.parse(this.savedSearchArray[i].savedSearchJson), this.page,
      this.pageSize, this.username);
  }

  populateUSAStates(): void {
    this.statesList = [
        {
          "usaStateId": 1,
          "usaState": "AL",
          "usaStateFull": "Alabama",
          "checked": false
        },
        {
          "usaStateId": 2,
          "usaState": "AK",
          "usaStateFull": "Alaska",
          "checked": false
        },
        {
          "usaStateId": 3,
          "usaState": "AR",
          "usaStateFull": "Arkansas",
          "checked": false
        },
        {
          "usaStateId": 4,
          "usaState": "AZ",
          "usaStateFull": "Arizona",
          "checked": false
        },
        {
          "usaStateId": 5,
          "usaState": "CA",
          "usaStateFull": "California",
          "checked": false
        },
        {
          "usaStateId": 6,
          "usaState": "CO",
          "usaStateFull": "Colorado",
          "checked": false
        },
        {
          "usaStateId": 7,
          "usaState": "CT",
          "usaStateFull": "Connecticut",
          "checked": false
        }, {
          "usaStateId": 51,
          "usaState": "DC",
          "usaStateFull": "Washington DC",
          "checked": false
        },
        {
          "usaStateId": 8,
          "usaState": "DE",
          "usaStateFull": "Delaware",
          "checked": false
        },
        {
          "usaStateId": 9,
          "usaState": "FL",
          "usaStateFull": "Florida",
          "checked": false
        },
        {
          "usaStateId": 10,
          "usaState": "GA",
          "usaStateFull": "Georgia",
          "checked": false
        },
        {
          "usaStateId": 11,
          "usaState": "HI",
          "usaStateFull": "Hawaii",
          "checked": false
        },
        {
          "usaStateId": 12,
          "usaState": "ID",
          "usaStateFull": "Idaho",
          "checked": false
        },
        {
          "usaStateId": 13,
          "usaState": "IL",
          "usaStateFull": "Illinois",
          "checked": false
        },
        {
          "usaStateId": 14,
          "usaState": "IN",
          "usaStateFull": "Indiana",
          "checked": false
        },
        {
          "usaStateId": 15,
          "usaState": "IA",
          "usaStateFull": "Iowa",
          "checked": false
        },
        {
          "usaStateId": 16,
          "usaState": "KS",
          "usaStateFull": "Kansas",
          "checked": false
        },
        {
          "usaStateId": 17,
          "usaState": "KY",
          "usaStateFull": "Kentucky",
          "checked": false
        },
        {
          "usaStateId": 18,
          "usaState": "LA",
          "usaStateFull": "Lousiana",
          "checked": false
        },
        {
          "usaStateId": 19,
          "usaState": "ME",
          "usaStateFull": "Maine",
          "checked": false
        },
        {
          "usaStateId": 20,
          "usaState": "MD",
          "usaStateFull": "Maryland",
          "checked": false
        },
        {
          "usaStateId": 21,
          "usaState": "MA",
          "usaStateFull": "Massachusetts",
          "checked": false
        },
        {
          "usaStateId": 22,
          "usaState": "MI",
          "usaStateFull": "Michigan",
          "checked": false
        },
        {
          "usaStateId": 23,
          "usaState": "MN",
          "usaStateFull": "Minnesota",
          "checked": false
        },
        {
          "usaStateId": 24,
          "usaState": "MS",
          "usaStateFull": "Mississippi",
          "checked": false
        },
        {
          "usaStateId": 25,
          "usaState": "MO",
          "usaStateFull": "Missouri",
          "checked": false
        },
        {
          "usaStateId": 26,
          "usaState": "MT",
          "usaStateFull": "Montana",
          "checked": false
        },
        {
          "usaStateId": 27,
          "usaState": "NE",
          "usaStateFull": "Nebraska",
          "checked": false
        },
        {
          "usaStateId": 28,
          "usaState": "NV",
          "usaStateFull": "Nevada",
          "checked": false
        },
        {
          "usaStateId": 29,
          "usaState": "NH",
          "usaStateFull": "New Hampshire",
          "checked": false
        },
        {
          "usaStateId": 30,
          "usaState": "NJ",
          "usaStateFull": "New Jersey",
          "checked": false
        },
        {
          "usaStateId": 31,
          "usaState": "NM",
          "usaStateFull": "New Mexico",
          "checked": false
        },
        {
          "usaStateId": 32,
          "usaState": "NY",
          "usaStateFull": "New York",
          "checked": false
        },
        {
          "usaStateId": 33,
          "usaState": "NC",
          "usaStateFull": "North Carolina",
          "checked": false
        },
        {
          "usaStateId": 34,
          "usaState": "ND",
          "usaStateFull": "North Dakota",
          "checked": false
        },
        {
          "usaStateId": 35,
          "usaState": "OH",
          "usaStateFull": "Ohio",
          "checked": false
        },
        {
          "usaStateId": 36,
          "usaState": "OK",
          "usaStateFull": "Oklahoma",
          "checked": false
        },
        {
          "usaStateId": 37,
          "usaState": "OR",
          "usaStateFull": "Oregan",
          "checked": false
        },
        {
          "usaStateId": 38,
          "usaState": "PA",
          "usaStateFull": "Pennsylvania",
          "checked": false
        }, {
          "usaStateId": 52,
          "usaState": "PR",
          "usaStateFull": "Puerto Rico",
          "checked": false
        },
        {
          "usaStateId": 39,
          "usaState": "RI",
          "usaStateFull": "Rhode Island",
          "checked": false
        },
        {
          "usaStateId": 40,
          "usaState": "SC",
          "usaStateFull": "South Carolina",
          "checked": false
        },
        {
          "usaStateId": 41,
          "usaState": "SD",
          "usaStateFull": "South Dakota",
          "checked": false
        },
        {
          "usaStateId": 42,
          "usaState": "TN",
          "usaStateFull": "Tennessee",
          "checked": false
        },
        {
          "usaStateId": 43,
          "usaState": "TX",
          "usaStateFull": "Texas",
          "checked": false
        },
        {
          "usaStateId": 44,
          "usaState": "UT",
          "usaStateFull": "Utah",
          "checked": false
        },
        {
          "usaStateId": 45,
          "usaState": "VT",
          "usaStateFull": "Vermont",
          "checked": false
        },
        {
          "usaStateId": 46,
          "usaState": "VA",
          "usaStateFull": "Virginia",
          "checked": false
        },
        {
          "usaStateId": 47,
          "usaState": "WA",
          "usaStateFull": "Washington",
          "checked": false
        },
        {
          "usaStateId": 48,
          "usaState": "WV",
          "usaStateFull": "West Virginia",
          "checked": false
        },
        {
          "usaStateId": 49,
          "usaState": "WI",
          "usaStateFull": "Wisconsin",
          "checked": false
        },
        {
          "usaStateId": 50,
          "usaState": "WY",
          "usaStateFull": "Wyoming",
          "checked": false
        }
    ];
    /*
    this.searchService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        //this.statesList = result.body;
        let i: number = 0;
        while (i < result.body.length) {
          this.statesList.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull USA States.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })*/
  }

  toggleAffiliationCodesFilter(): void {
    this.affiliationCodeButton = !this.affiliationCodeButton;
  }

  addValToAffiliationCodes(idValue:number): void {
    const affiliationCodeEl = document.getElementById('flexCheckCheckedAffiliationCode-' + idValue);
    // @ts-ignore
    const affiliationCodeChecked = affiliationCodeEl.checked;
    this.affiliationCodeCheckboxes[idValue]['checked'] = affiliationCodeChecked;
  }

  populateAffiliationCodeCheckboxes(): void {
    this.searchService.getAffiliationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.affiliationCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Affiliation Codes.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  toggleDeductabilityCodesFilter(): void {
    this.deductabilityCodeButton = !this.deductabilityCodeButton;
  }

  addValToDeductabilityCodes(idValue:number): void {
    const deductabilityCodeEl = document.getElementById('flexCheckCheckedDeductabilityCode-' + idValue);
    // @ts-ignore
    const deductabilityCodeChecked = deductabilityCodeEl.checked;
    this.deductabilityCodeCheckboxes[idValue]['checked'] = deductabilityCodeChecked;
  }
  populateDeductabilityCodeCheckboxes(): void {
    this.searchService.getDeductibilityCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.deductabilityCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Deductibility Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleEoSubsectionClassificationCodesFilter(): void {
    this.eoSubsectionClassificationCodeButton = !this.eoSubsectionClassificationCodeButton;
  }

  addValToEoClassificationSubsectionCodes(idValue:number): void {
    const eoSubsectionClassificationCodeEl = document.getElementById('flexCheckCheckedEoSubsectionClassificationCode-' + idValue);
    // @ts-ignore
    const eoSubsectionClassificationCodeChecked = eoSubsectionClassificationCodeEl.checked;
    this.eoSubsectionClassificationCodeCheckboxes[idValue]['checked'] = eoSubsectionClassificationCodeChecked;
  }

  populateEoClassificationSubsectionCodeCheckboxes(): void {
    this.searchService.getEOSubsectionClassificationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.eoSubsectionClassificationCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      console.log(error);
    });
  }

  populateEoSubsectionCodeCheckboxes(): void {

  }

  toggleFilingReqCodesFilter(): void {
    this.filingReqCodeButton = !this.filingReqCodeButton;
  }

  addValToFilingReqCodes(idValue:number): void {
    const filingReqCodeEl = document.getElementById('flexCheckCheckedFilingReqCode-' + idValue);
    // @ts-ignore
    const filingReqCodeChecked = filingReqCodeEl.checked;
    this.filingReqCodeCheckboxes[idValue]['checked'] = filingReqCodeChecked;
  }
  populateFilingReqCodeCheckboxes(): void {
    this.searchService.getFilingReqCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.filingReqCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Filing Requirement Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  populatePfFilingReqCodeCheckboxes(): void {
    this.pfFilingReqCodeCheckboxes = [];
  }

  toggleFoundationCodesFilter(): void {
    this.foundationCodeButton = !this.foundationCodeButton;
  }

  addValToFoundationCodes(idValue:number): void {
    const foundationCodeEl = document.getElementById('flexCheckCheckedFoundationCode-' + idValue);
    // @ts-ignore
    const foundationCodeChecked = foundationCodeEl.checked;
    this.foundationCodeCheckboxes[idValue]['checked'] = foundationCodeChecked;
  }

  populateFoundationCodeCheckboxes(): void {
    this.searchService.getFoundationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.foundationCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Foundation Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleNteeCodesFilter(): void {
    this.nteeCodeButton = !this.nteeCodeButton;
  }
  addValToNteeCodes(idValue:number): void {
    const nteeCodeEl = document.getElementById('flexCheckCheckedNteeCode-' + idValue);
    // @ts-ignore
    const nteeCodeChecked = nteeCodeEl.checked;
    this.nteeCodeCheckboxes[idValue]['checked'] = nteeCodeChecked;
  }

  populateNteeCodeCheckboxes(): void {
    this.searchService.getNteeCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nteeCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull NTEE Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }


  toggleNteeParentCodesFilter(): void {
    this.nteeParentCodeButton = !this.nteeParentCodeButton;
  }
  addValToNteeParentCodes(idValue:number): void {
    const nteeParentCodeEl = document.getElementById('flexCheckCheckedNteeParentCode-' + idValue);
    // @ts-ignore
    const nteeParentCodeChecked = nteeParentCodeEl.checked;
    this.nteeParentCodeCheckboxes[idValue]['checked'] = nteeParentCodeChecked;
  }

  populateNteeParentCodeCheckboxes(): void {
    this.searchService.getNteeParentCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.nteeParentCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull NTEE Parent Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleOrganizationCodesFilter(): void {
    this.organizationCodeButton = !this.organizationCodeButton;
  }
  addValToOrganizationCodes(idValue:number): void {
    const organizationCodeEl = document.getElementById('flexCheckCheckedOrganizationCode-' + idValue);
    // @ts-ignore
    const organizationCodeChecked = organizationCodeEl.checked;
    this.organizationCodeCheckboxes[idValue]['checked'] = organizationCodeChecked;
  }

  populateOrganizationCodeCheckboxes(): void {
    this.searchService.getOrganizationCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.organizationCodeCheckboxes = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Organization Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleReturnTypeCodesFilter(): void {
    this.returnTypeCodeButton = !this.returnTypeCodeButton;
  }

  addValToReturnTypeCodes(idValue:number): void {
    const returnTypeCodeEl = document.getElementById('flexCheckCheckedReturnTypeCode-' + idValue);
    // @ts-ignore
    const returnTypeCodeChecked = returnTypeCodeEl.checked;
    this.returnTypeCodeCheckboxes[idValue]['checked'] = returnTypeCodeChecked;
  }

  populateReturnTypeCodeCheckboxes(): void {
    const browserUrl: string = window.location.href;
    this.searchService.getReturnTypeCodesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.returnTypeCodeCheckboxes = result.body;
        if (browserUrl.includes('nonprofits')) {
          for ( const returnTypeCodeCheckboxTemp of this.returnTypeCodeCheckboxes) {
            if (returnTypeCodeCheckboxTemp['returnTypeCodeName'] !== '990PF') {
              returnTypeCodeCheckboxTemp['checked'] = true;
            } else {
              returnTypeCodeCheckboxTemp['checked'] = false;
            }
          }
        } else if (browserUrl.includes('donors')) {
          for ( const returnTypeCodeCheckboxTemp of this.returnTypeCodeCheckboxes) {
            if (returnTypeCodeCheckboxTemp['returnTypeCodeName'] === '990PF') {
              returnTypeCodeCheckboxTemp['checked'] = true;
            } else {
              returnTypeCodeCheckboxTemp['checked'] = false;
            }
          }
        } else {
          //should never happen
        }
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Return Type Codes',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleAdvancedFilters(): any {
    this.advancedFiltersButton = !this.advancedFiltersButton;
  }

  toggleTotalAssetsFilter(): any {
    this.totalAssetsButton = !this.totalAssetsButton;
  }

  trackTotalAssetsRange(idValue:number): void {
    //Clear Radio Buttons
    for (const radioButton of this.totalAssetsRadioButtons) {
      if (this.totalAssetsRadioButtons[idValue]['checked']) {
        continue;
      } else {
        radioButton.checked = false;
      }
    }
    const totalAssetsRangeEl = document.getElementById('flexRadioTotalAssets-' + idValue);
    this.totalAssetsRadioButtons[idValue]['checked'] = !this.totalAssetsRadioButtons[idValue]['checked'];
    // @ts-ignore
    totalAssetsRangeEl.checked = this.totalAssetsRadioButtons[idValue]['checked']
  }

  populateTotalAssetsRangeRadioButtons(): void {
    this.searchService.getTotalAssetsRangeDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.totalAssetsRadioButtons = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Total Asset Range Filters',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleTotalIncomeFilter(): any {
    this.totalIncomeButton = !this.totalIncomeButton;
  }

  trackTotalIncomeRange(idValue:number): void {
    //Clear Radio Buttons
    for (const radioButton of this.totalIncomeRadioButtons) {
      if (this.totalIncomeRadioButtons[idValue]['checked']) {
        continue;
      } else {
        radioButton.checked = false;
      }
    }
    const totalIncomeRangeEl = document.getElementById('flexRadioTotalIncome-' + idValue);
    this.totalIncomeRadioButtons[idValue]['checked'] = !this.totalIncomeRadioButtons[idValue]['checked'];
    // @ts-ignore
    totalIncomeRangeEl.checked = this.totalIncomeRadioButtons[idValue]['checked']
  }

  populateTotalIncomeRangeRadioButtons(): void {
    this.searchService.getTotalIncomeRangeDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.totalIncomeRadioButtons = result.body;
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Total Income Range Filters',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  toggleRevokeLogicalExpression(): void {
    this.includeTaxExemptRevoked = !this.includeTaxExemptRevoked;
  }

  trackLogicalExpression(logicalOperator: string): void {
    if (logicalOperator == 'AND') {
      this.logicalOperatorAnd = true;
      this.logicalOperatorOr = false;
    } else if (logicalOperator == 'OR') {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    } else {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    }
  }

  populateCauseCategories(): void {
    this.searchService.getCausesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.causeDropdownList = result.body;
        this.populateCauseGivingInterestsDropdown();
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Causes Drop down',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  updateCauseGivingInterestsDropdown(): boolean {
    var causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    let causeCategorySelVal = causeCategorySel.value;
    if (causeCategorySel) {
      if (this.causeGivingInterestsObj[causeCategorySelVal]) {
        //this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj[causeCategorySelVal]
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj[causeCategorySelVal]
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsDropdownList.concat(
          [{givingInterestDisplayName: 'All Other Cause Category Giving Interests', givingInterestName: 'ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' }], this.causeGivingInterestsObj['ALL'])
      } else {
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj['ALL'];
      }
    }
    return true;
  }

  populateCauseGivingInterestsDropdown(): void {
    this.searchService.getAllGivingInterestsDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.causeGivingInterestsObj = result.body;
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj['ALL']
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Donor Error',
        detail: 'Failed to pull Causes Giving Interests Drop down',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  addCauseGivingInterestFilter(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;

    if (causeGivingInterestSelected) {
      if (addFlag) {
        this.givingInterestsSetObj[causeGivingInterestSelected] = 0;
        this.recalculateListOfGivingInterests();
      } else {
        this.givingInterestsWithoutSetObj[causeGivingInterestSelected] = 0;
        this.recalculateListOfGivingInterestsWithout();
      }
    }
  }

  addCauseGivingInterestFilter2(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;
    if (causeGivingInterestSelected) {
      if ('ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' == causeGivingInterestSelected) {
        return;
      }
      if (addFlag) {
        this.recalculateListOfGivingInterests2(causeGivingInterestSelected);
      } else {
        this.recalculateListOfGivingInterestsWithout2(causeGivingInterestSelected);
      }
    }
  }

  onDeleteGivingInterest(row: string): void {
    const index = this.causeGivingInterestsList.indexOf(row);
    const size = this.causeGivingInterestsList.length;
    const causeGivingInterestsListTemp: string[] = []
    if (size == 1) {
      this.causeGivingInterestsList = [];
      return;
    }
    if (index == (size - 1) ) {
      let excludedSize: number = size - 2;
      let i = 0;
      while (i < excludedSize) {
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
        i = i + 1;
      }
      this.causeGivingInterestsList = causeGivingInterestsListTemp;
      return;
    }
    let i = 0;
    while (i < size) {
      if (index == 0 && i == 0 && size > 1) {
        //skip elements 0 and 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
      } else if (index == i && size > 1) {
        //skip elements i and i + 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
      } else {
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
      }
      i = i + 1;
    }
    this.causeGivingInterestsList = causeGivingInterestsListTemp;
  }

  onDeleteGivingInterestWithout(row: string): void {
    const index = this.causeGivingInterestsWithoutList.indexOf(row);
    const size = this.causeGivingInterestsWithoutList.length;
    const causeGivingInterestsWithoutListTemp: string[] = [];
    let i = 0;
    while (i < size) {
      if (i != index) {
        causeGivingInterestsWithoutListTemp.push(this.causeGivingInterestsWithoutList[i]);
      }
      i = i + 1;
    }
    this.causeGivingInterestsWithoutList = causeGivingInterestsWithoutListTemp;
  }

  recalculateListOfGivingInterests(): void {
    this.causeGivingInterestsList = [];
    for (const givingInterest in this.givingInterestsSetObj) {
      this.causeGivingInterestsList.push(givingInterest);
    }
  }
  recalculateListOfGivingInterests2(causingGivingInterest: string): void {
    if (this.causeGivingInterestsList.length > 0) {
      if (this.logicalOperatorAnd && !this.logicalOperatorOr) {
        this.causeGivingInterestsList.push("AND");
      } else if (!this.logicalOperatorAnd && this.logicalOperatorOr) {
        this.causeGivingInterestsList.push("OR");
      } else {
        this.causeGivingInterestsList.push("OR");
      }
    }
    this.causeGivingInterestsList.push(causingGivingInterest);
  }

  recalculateListOfGivingInterestsWithout2(causingGivingInterest: string): void {
    this.causeGivingInterestsWithoutList.push(causingGivingInterest);
  }

  recalculateObjOfGivingInterests(): void {
    this.givingInterestsSetObj = {};
    console.log('this.causeGivingInterestsList: ' + JSON.stringify(this.causeGivingInterestsList));
    for (const givingInterest in this.causeGivingInterestsList) {
      this.givingInterestsSetObj[givingInterest] = 1;
    }
  }

  recalculateListOfGivingInterestsWithout(): void {
    this.causeGivingInterestsWithoutList = [];
    for (const givingInterestWithout in this.givingInterestsWithoutSetObj) {
      this.causeGivingInterestsWithoutList.push(givingInterestWithout);
    }
  }

  recalculateObjOfGivingInterestsWithout(): void {
    this.givingInterestsWithoutSetObj = {};
    console.log('this.causeGivingInterestsWithoutList: ' + JSON.stringify(this.causeGivingInterestsWithoutList));
    for (const givingInterestWithout in this.causeGivingInterestsWithoutList) {
      this.givingInterestsWithoutSetObj[givingInterestWithout] = 1;
    }
  }

  deleteGivingInterestChip(givingInterestChipStr : string, parentElement: any): void {
    parentElement.style.display = 'none';
    delete this.givingInterestsSetObj[givingInterestChipStr];
  }

  deleteGivingInterestWithoutChip(givingInterestWithoutChipStr : string, parentElement: any): void {
    parentElement.style.display = 'none';
    delete this.givingInterestsWithoutSetObj[givingInterestWithoutChipStr];
  }

  deleteGivingInterestChip2(event: Event): void {
    // @ts-ignore
    console.log('deleteGivingInterestChip2: ')
    // @ts-ignore
    //delete this.givingInterestsSetObj[event.target.value];
    this.recalculateObjOfGivingInterests();
  }

  deleteGivingInterestWithoutChip2(event: Event): void {
    // @ts-ignore
    console.log('deleteGivingInterestWithoutChip2: ')
    // @ts-ignore
    //delete this.givingInterestsWithoutSetObj[event.target.value];
    this.recalculateObjOfGivingInterestsWithout();
  }

  deleteGivingInterestChip3(row: any): void {
    // @ts-ignore
    console.log('deleteGivingInterestChip2: ' + JSON.stringify(row));
    let newList: any[] = [];
    for (const rowTemp of this.causeGivingInterestsList) {
      if (rowTemp != row) {
        newList.push(rowTemp);
      }
    }
    this.causeGivingInterestsList = newList;

    this.recalculateObjOfGivingInterests();
  }

  deleteGivingInterestWithoutChip3(row: any): void {
    // @ts-ignore
    console.log('deleteGivingInterestWithoutChip2: ' + JSON.stringify(row));
    let newList: any[] = [];
    for (const rowTemp of this.causeGivingInterestsWithoutList) {
      if (rowTemp != row) {
        newList.push(rowTemp);
      }
    }
    this.causeGivingInterestsWithoutList = newList;
    this.recalculateObjOfGivingInterestsWithout();
  }

  onApplySavedSearch(): void {
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    let savedSearchEl = document.getElementById('saved-search-selector-id');
    // @ts-ignore
    let savedSearchId: number = savedSearchEl.value;
    let i: number = 0;
    let foundFlag: boolean = false;
    for (const savedSearchObj of this.savedSearchArray) {
      if (savedSearchObj.savedSearchId == savedSearchId) {
        foundFlag = true;
        break;
      }
      i = i + 1;
    }
    if (!foundFlag) {
      this.sideNavErrorMessages.push({
        field: 'Saved Search Error',
        detail: 'Please enter a saved search.....',
        severity: 'error'
      });
      this.showSideNavErrorMessagesToUser();
      return;
    }
    localStorage.setItem('lastSearchDonor', this.savedSearchArray[i].savedSearchJson);
    this.executeSearchPages(JSON.parse(this.savedSearchArray[i].savedSearchJson), this.page, this.pageSize, this.username);
  }

  onSearch(searchToBeSaved: boolean): any {
    this.loadingIcon = false;
    this.showErrorMessages = false;
    this.errorMessages = [];
    this.showSuccessMessages = false;
    this.successMessages = [];
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    //Build search dto from checkboxes
    let nonEmptyFilterFlag : boolean = false;
    this.names = [];
    const namesEl = document.getElementById('name-with-text-id');
    // @ts-ignore
    const namesSelected = namesEl.value;
    if (namesSelected) {
      const cleanNames: string = this.apiService.trimLeadingTrailingSpaces(namesSelected);
      let namesFinal: string[] = cleanNames.split(",");
      if (namesFinal.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Foundation Names limit exceeded. You are limited to 10 Foundation Names.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < namesFinal.length; i = i + 1) {
        this.names.push(this.apiService.trimLeadingTrailingSpaces(namesFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }

    this.namesWithout = [];
    /*
    const nameWithoutEl = document.getElementById('name-without-text-id');
    // @ts-ignore
    const nameWithoutSelected = nameWithoutEl.value;
    if (nameWithoutSelected) {
      const cleanNamesWithout: string = this.apiService.trimLeadingTrailingSpaces(nameWithoutSelected);
      let namesWithoutFinal: string[] = cleanNamesWithout.split(",");
      if (namesWithoutFinal.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded Foundation Names limit exceeded. You are limited to 10 Foundation Names.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < namesWithoutFinal.length; i = i + 1) {
        this.namesWithout.push(this.apiService.trimLeadingTrailingSpaces(namesWithoutFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }*/

    this.eins = [];
    const einsEl = document.getElementById('ein-text-id');
    // @ts-ignore
    const einsSelected = einsEl.value;
    if (einsSelected) {
      this.eins.push(this.apiService.trimLeadingTrailingSpaces(einsSelected));
      nonEmptyFilterFlag = true;
    }

    this.states = [];
    const usaStatesEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const usaStatesSelected = usaStatesEl.value;
    if (usaStatesSelected) {
      this.states.push(this.apiService.trimLeadingTrailingSpaces(usaStatesSelected));
      nonEmptyFilterFlag = true;
    }


    this.taxYear = 2024;
    const taxYearEl = document.getElementById('tax-year-dropdown-list-id');
    // @ts-ignore
    const taxYearSelected = taxYearEl.value;
    if (taxYearSelected) {
      this.taxYear = parseInt(taxYearSelected);
      nonEmptyFilterFlag = true;
    }

    this.donatedGrantsStates = [];
    const donatedGrantsUsaStatesEl = document.getElementById('dg-usa-dropdown-list-id');
    // @ts-ignore
    const donatedGrantsUsaStatesSelected = donatedGrantsUsaStatesEl.value;
    console.log('donatedGrantsUsaStatesSelected: ' + donatedGrantsUsaStatesSelected)
    if (donatedGrantsUsaStatesSelected) {
      this.donatedGrantsStates.push(this.apiService.trimLeadingTrailingSpaces(donatedGrantsUsaStatesSelected));
      nonEmptyFilterFlag = true;
    }

    this.cities = [];
    const citiesEl = document.getElementById('cities-text-id');
    // @ts-ignore
    const citiesSelected: string = citiesEl.value;
    if (citiesSelected) {
      let cleanCities: string = this.apiService.trimLeadingTrailingSpaces(citiesSelected);
      let citiesFinal: string[] = cleanCities.split(",");
      if (citiesFinal.length > 10) {
        this.sideNavErrorMessages.push({
            field: 'Filter Error',
            detail: 'Included Cities limit exceeded. You are limited to 10 cities.',
            severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < citiesFinal.length; i = i + 1) {
        let finalCity = this.apiService.trimLeadingTrailingSpaces(citiesFinal[i])
        if (finalCity && !finalCity.startsWith(':')) {
          this.cities.push(finalCity);
        }
      }
      nonEmptyFilterFlag = true;
    }

    this.donatedGrantsCities = [];
    const donatedGrantsCitiesEl = document.getElementById('donated-grants-cities-text-id');
    // @ts-ignore
    const donatedGrantsCitiesSelected: string = donatedGrantsCitiesEl.value;
    console.log('donatedGrantsCitiesSelected: ' + donatedGrantsCitiesSelected)
    if (donatedGrantsCitiesSelected) {
      let cleanDonatedGrantsCities: string = this.apiService.trimLeadingTrailingSpaces(donatedGrantsCitiesSelected);
      let donatedGrantsCitiesFinal: string[] = cleanDonatedGrantsCities.split(",");
      if (donatedGrantsCitiesFinal.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < donatedGrantsCitiesFinal.length; i = i + 1) {
        this.donatedGrantsCities.push(this.apiService.trimLeadingTrailingSpaces(donatedGrantsCitiesFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }

    this.citiesWithout = [];
    /*
    const citiesWithoutEl = document.getElementById('cities-without-text-id');
    // @ts-ignore
    const citiesWithoutSelected = citiesWithoutEl.value;
    if (citiesWithoutSelected) {
      let cleanCitiesWithout: string = this.apiService.trimLeadingTrailingSpaces(citiesWithoutSelected);
      let citiesWithoutFinal: string[] = cleanCitiesWithout.split(",");
      if (citiesWithoutFinal.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded Cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < citiesWithoutFinal.length; i = i + 1) {
        this.citiesWithout.push(this.apiService.trimLeadingTrailingSpaces(citiesWithoutFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }*/

    this.zipCodes = [];
    const zipCodesEl = document.getElementById('zip-code-text-id');
    // @ts-ignore
    const zipCodesSelected = zipCodesEl.value;
    if (zipCodesSelected) {
      this.zipCodes.push(this.apiService.trimLeadingTrailingSpaces(zipCodesSelected));
      nonEmptyFilterFlag = true;
    }
    this.minYearsInBusiness = 0;
    /*
    const minYearsInBusinessEl = document.getElementById('min-years-in-business-text-id');
    if (minYearsInBusinessEl) {
      if (this.minYearsInBusiness > 0) {
        // @ts-ignore
        this.minYearsInBusiness = parseInt(minYearsInBusinessEl.value);
        nonEmptyFilterFlag = true;
      }
    }*/
    this.includeTaxExemptRevoked = false;
    /*
    const includeTaxExemptRevokedEl = document.getElementById('flexRadioIncludeRevocationList');
    if (includeTaxExemptRevokedEl) {
      // @ts-ignore
      this.includeTaxExemptRevoked = includeTaxExemptRevokedEl.checked;
      nonEmptyFilterFlag = true;
    }*/

    this.counties = [];
    /*
    const countyEl = document.getElementById('counties-text-id');
    // @ts-ignore
    const countySelected = countyEl.value;
    console.log('countySelected: ' + JSON.stringify(countySelected));
    if (countySelected) {
      this.counties.push(countySelected);
      nonEmptyFilterFlag = true;
    }*/

    this.countiesWithout = [];
    /*
    const countyWithoutEl = document.getElementById('counties-without-text-id');
    // @ts-ignore
    const countyWithoutSelected = countyWithoutEl.value;
    console.log('countyWithoutSelected: ' + JSON.stringify(countyWithoutSelected));
    if (countyWithoutSelected) {
      this.countiesWithout.push(countyWithoutSelected);
      nonEmptyFilterFlag = true;
    }*/

    this.affiliationCodeIds = [];
    for (const affiliationCodeCheckboxTemp of this.affiliationCodeCheckboxes) {
      if (affiliationCodeCheckboxTemp.checked === true) {
        this.affiliationCodeIds.push(affiliationCodeCheckboxTemp.affiliationCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.deductabilityCodeIds = [];
    for (const deductabilityCodeCheckboxTemp of this.deductabilityCodeCheckboxes) {
      if (deductabilityCodeCheckboxTemp.checked === true) {
        this.deductabilityCodeIds.push(deductabilityCodeCheckboxTemp.deductabilityCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.eoClassificationCodes = [];
    this.eoSubsectionCodes = [];

    this.filingReqCodeIds = [];
    for (const filingReqCodeCheckboxTemp of this.filingReqCodeCheckboxes) {
      if (filingReqCodeCheckboxTemp.checked === true) {
        this.filingReqCodeIds.push(filingReqCodeCheckboxTemp.filingReqCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.foundationCodeIds = [];
    for (const foundationCodeCheckboxTemp of this.foundationCodeCheckboxes) {
      if (foundationCodeCheckboxTemp.checked === true) {
        this.foundationCodeIds.push(foundationCodeCheckboxTemp.foundationCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.nteeCodeIds = [];
    for (const nteeCodeCheckboxTemp of this.nteeCodeCheckboxes) {
      if (nteeCodeCheckboxTemp.checked === true) {
        this.nteeCodeIds.push(nteeCodeCheckboxTemp.nteeCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.nteeParentCodeIds = [];
    for (const nteeParentCodeCheckboxTemp of this.nteeParentCodeCheckboxes) {
      if (nteeParentCodeCheckboxTemp.checked === true) {
        this.nteeParentCodeIds.push(nteeParentCodeCheckboxTemp.nteeParentCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.organizationCodeIds = [];
    for (const organizationCodeCheckboxTemp of this.organizationCodeCheckboxes) {
      if (organizationCodeCheckboxTemp.checked === true) {
        this.organizationCodeIds.push(organizationCodeCheckboxTemp.organizationCodeId);
        nonEmptyFilterFlag = true;
      }
    }

    this.returnTypeCodeIds = [];
    for (const returnTypeCodeCheckboxTemp of this.returnTypeCodeCheckboxes) {
      if (returnTypeCodeCheckboxTemp.checked === true) {
        this.returnTypeCodeIds.push(returnTypeCodeCheckboxTemp.returnTypeCodeId);
        //nonEmptyFilterFlag = true;
      }
    }

    //Time Varying Parameters
    //Total Assets Range
    this.totalAssetsRange = [];
    for (const totalAssetsRadioButtonTemp of this.totalAssetsRadioButtons) {
      if (totalAssetsRadioButtonTemp.checked === true) {
        this.totalAssetsRange.push(totalAssetsRadioButtonTemp.minTotalAssets);
        this.totalAssetsRange.push(totalAssetsRadioButtonTemp.maxTotalAssets);
        nonEmptyFilterFlag = true;
      }
    }

    this.totalIncomeRange = [];
    for (const totalIncomeRadioButtonTemp of this.totalIncomeRadioButtons) {
      if (totalIncomeRadioButtonTemp.checked === true) {
        this.totalIncomeRange.push(totalIncomeRadioButtonTemp.minTotalIncome);
        this.totalIncomeRange.push(totalIncomeRadioButtonTemp.maxTotalIncome);
        nonEmptyFilterFlag = true;
      }
    }

    this.causes = [];

    //Key Employees
    this.keyStaff = [];
    const keyStaffEl = document.getElementById('key-staff-text-id');
    // @ts-ignore
    const keyStaffSelected = keyStaffEl.value;
    //console.log('keyStaffSelected: ' + JSON.stringify(keyStaffSelected));
    if (keyStaffSelected) {
      this.keyStaff.push(this.apiService.trimLeadingTrailingSpaces(keyStaffSelected));
      nonEmptyFilterFlag = true;
    }

    //Giving Interests build list
    if (this.causeGivingInterestsList.length > 0) {
      if (this.causeGivingInterestsList.length > 19){
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Cause Category Giving Interests limit exceeded. You are limited to 10 Cause Category Giving Interests.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      nonEmptyFilterFlag = true;
    }
    //this.causeGivingInterestsList = [];
    //console.log('this.givingInterestsSetObj: ' + JSON.stringify(this.givingInterestsSetObj));

    //Giving Interests Without build list
    if (this.causeGivingInterestsWithoutList.length > 0) {
      if (this.causeGivingInterestsWithoutList.length > 19){
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded Cause Category Giving Interests limit exceeded. You are limited to 10 Cause Category Giving Interests.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      nonEmptyFilterFlag = true;
    }
    //console.log('this.givingInterestsWithoutSetObj: ' + JSON.stringify(this.givingInterestsWithoutSetObj));

    this.sortByCompanyNameAscId = 0;
    if (this.companyNameAscRadioButton) {
      this.sortByCompanyNameAscId = 1;
    } else if (this.companyNameDescRadioButton) {
      this.sortByCompanyNameAscId = 2;
    }

    this.sortByCityAscId = 0;
    if (this.cityAscRadioButton) {
      this.sortByCityAscId = 1;
    } else if (this.cityDescRadioButton) {
      this.sortByCityAscId = 2;
    }

    this.sortByStateAscId = 0;
    if (this.stateAscRadioButton) {
      this.sortByStateAscId = 1;
    } else if (this.stateDescRadioButton) {
      this.sortByStateAscId = 2;
    }

    this.sortByTotalAssetsAscId = 0;
    if (this.totalAssetsAscRadioButton) {
      this.sortByTotalAssetsAscId = 1;
    } else if (this.totalAssetsDescRadioButton) {
      this.sortByTotalAssetsAscId = 2;
    }

    if (this.names.length == 0 && this.eins.length == 0 && this.states.length == 0 && this.cities.length == 0 &&
        this.donatedGrantsCities.length == 0 && this.donatedGrantsStates.length == 0 &&
        this.zipCodes.length == 0 && this.affiliationCodeIds.length == 0 && this.deductabilityCodeIds.length == 0 &&
        this.eoClassificationCodes.length == 0 && this.eoSubsectionCodes.length == 0 && this.filingReqCodeIds.length == 0 &&
        this.pfFilingReqCodeIds.length == 0 && this.foundationCodeIds.length == 0 && this.nteeCodeIds.length == 0 &&
        this.nteeParentCodeIds.length == 0 && this.organizationCodeIds.length == 0 && this.totalAssetsRange.length == 0 &&
        this.totalIncomeRange.length == 0 && this.causeGivingInterestsList.length == 0 && this.keyStaff.length == 0) {
      // Empty search query
      nonEmptyFilterFlag = false;
    }

    const filter: SearchIDsCriteriaDto = {
      'names': this.names,
      'namesWithout': this.namesWithout,
      'eins': this.eins,
      'states': this.states,
      'cities': this.cities,
      'citiesWithout': this.citiesWithout,
      'zipCodes': this.zipCodes,
      'includeTaxExemptRevoked': this.includeTaxExemptRevoked,
      'minYearsInBusiness': this.minYearsInBusiness,
      'donatedGrantsCities': this.donatedGrantsCities,
      'donatedGrantsStates': this.donatedGrantsStates,
      'taxYear': this.taxYear,
      'counties': this.counties,
      'countiesWithout': this.countiesWithout,
      'affiliationCodeIds': this.affiliationCodeIds,
      'deductibilityCodeIds': this.deductabilityCodeIds,
      'eoClassificationCodes': this.eoClassificationCodes,
      'eoSubsectionCodes': this.eoSubsectionCodes,
      'filingReqCodeIds': this.filingReqCodeIds,
      'pfFilingReqCodeIds': this.pfFilingReqCodeIds,
      'foundationCodeIds': this.foundationCodeIds,
      'nteeCodeIds': this.nteeCodeIds,
      'nteeParentCodeIds': this.nteeParentCodeIds,
      'organizationCodeIds': this.organizationCodeIds,
      'returnTypeCodeIds': this.returnTypeCodeIds,
      'totalAssetsRange': this.totalAssetsRange,
      'totalIncomeRange': this.totalIncomeRange,
      'causes': this.causes,
      'causeGivingInterests': this.causeGivingInterestsList,
      'causeGivingInterestsWithout': this.causeGivingInterestsWithoutList,
      'keyStaff': this.keyStaff,
      'sortByCompanyNameAsc': this.sortByCompanyNameAscId,
      'sortByCityAsc': this.sortByCityAscId,
      'sortByStateAsc': this.sortByStateAscId,
      'sortByTotalAssetsAsc': this.sortByTotalAssetsAscId
    }

    if (!nonEmptyFilterFlag) {
      this.sideNavErrorMessages.push({
        field: 'Search Filter Error',
        detail: 'Please submit a non empty filter.',
        severity: 'error'
      });
      this.showSideNavErrorMessagesToUser();
      return false;
    }
    //Expire 2 hours from now
    let expirationTimestamp: number = Date.now() + 1000*3600*2;
    localStorage.setItem('lastSearchDonor', JSON.stringify(filter));
    localStorage.setItem('lastSearchDonorExpTime', expirationTimestamp.toString());
    this.page = 1;
    this.pageSize = 100;
    const pageDropdownEl = document.getElementById('search-donors-pagination-id-page-size-dropdown-list-id');
    // @ts-ignore
    const newPageSize: number = parseInt(pageDropdownEl.value);
    if (newPageSize) {
      this.pageSize = newPageSize;
    }
    //Submit to API
    // @ts-ignore
    const username: string = localStorage.getItem('username');
    if (searchToBeSaved) {
      const savedSearchNameEl = document.getElementById('saved-search-name-text-id');
      // @ts-ignore
      const savedSearchName = savedSearchNameEl.value;
      this.saveSearchToDatabase(JSON.stringify(filter), username, savedSearchName);
    } else {
      // @ts-ignore
      this.executeSearchPages(filter, this.page, this.pageSize, username);
    }
    return true;
  }

  loadSearchTypeNameMap(): void {
    this.searchService.getSearchTypeNamesDropdown(this.username)
      .subscribe((result: any) => {
        if (result && result.body) {
          for (const searchTypeNameTemp of result.body){
            this.searchTypeNameMap[searchTypeNameTemp.searchTypeName] = searchTypeNameTemp.searchTypeId;
          }
        }
        return;
      }, (err: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Donor API Error:',
          detail: 'Failed to pull the Search Type Names',
          severity: 'error'
        })
        this.showPageErrorMessagesToUser();
        return;
      });
    return;
  }

  saveSearchToDatabase(filter: string, username: string, savedSearchName: string) {
    const savedSearchDto: any = {
      savedSearchId: -1,
      userId: -1,
      savedSearchName: savedSearchName,
      searchTypeDto: {
        searchTypeId: this.searchTypeNameMap['DONOR_SEARCH'],
        searchTypeName: 'DONOR_SEARCH'
      },
      savedSearchJson: filter,
      createdTS: new Date(),
      updatedTS: new Date()
    }

    this.userService.editSavedSearch(savedSearchDto, username).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.currentSavedSearchDto = result.body;
          this.getSavedSearches();
          this.successMessages.push({
            field: 'Donor Saved Search Successful',
            detail: 'Successfully updated the saved search name: ' + savedSearchDto.savedSearchName,
            severity: 'success'
          });
          this.showSuccessMessagesToUser();

        }
      }, (err: HttpErrorResponse) => {
        this.errorMessages.push({
          field: 'Donor Saved Search API Failure',
          detail: 'Failed to update the saved search name: ' + savedSearchDto.savedSearchName,
          severity: 'error'
        });
        this.showErrorMessagesToUser();
      }
    );
  }

  onSave(): any {

    return true;
  }

  onExportToExcel(): any {
    this.showErrorMessages = false;
    this.errorMessages = [];
    this.showSuccessMessages = false;
    this.successMessages = [];
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    if (this.customerTrialVerified) {
      this.pageErrorMessages.push({
        field: 'Cannot Export to CSV',
        detail: 'You are in customer trial mode. You can only export to CSV with a paid subscription.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser(16000);
      return
    }
    const lastSearchJsonString = localStorage.getItem('lastSearchDonor');
    // @ts-ignore
    const lastSearchFilter: any = JSON.parse(lastSearchJsonString);
    const username = localStorage.getItem('username');
    this.pageSize = 100;//default
    const pageDropdownEl = document.getElementById('search-donors-pagination-id-page-size-dropdown-list-id');
    // @ts-ignore
    const newPageSize: number = parseInt(pageDropdownEl.value);
    if (newPageSize) {
      this.pageSize = newPageSize;
    }
    // @ts-ignore
    this.searchService.getDonorsPagesForExcel(lastSearchFilter, this.page, this.pageSize, username).subscribe(
      (result: any) => {
      let limitCode = result.headers.get('limitCode');
      //let featureExportLimitRows = result.headers.get('featureExportLimitRows');
      //let featureExportCurrentRows = result.headers.get('featureExportCurrentRows');
      //let featureExportFutureRows = result.headers.get('featureExportFutureRows');
      if (result && result.body) {
        if (limitCode == "2") {
          this.pageErrorMessages.push({
            field: 'Donors Download Failure',
            detail: 'Woah-woah! Our Search Donors tool is meant for online use. You are already at your Weekly limit of 10 downloads.' +
              ' If you need bulk download, please email us to temporarily bump up your limit.',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser(16000);
        } else if (limitCode == "1") {
          this.pageErrorMessages.push({
            field: 'Donors Download Failure',
            detail: 'Woah-woah! Our Search Donors tool is meant for online use. You are already at your Daily limit of 2 downloads.' +
              ' If you need bulk download, please email us to temporarily bump up your limit.',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser(16000);
        } else {
          this.pageSuccessMessages.push({
            field: 'Donors Export Successful',
            detail: 'Donors successfully exported to csv...',
            severity: 'success'
          });
          let fileName: string = 'donor_search_table.csv';
          saveAs(result.body, fileName);
          this.showPageSuccessMessagesToUser(16000);
        }
      }
    }, (err: HttpErrorResponse) => {
        if (this.customerTrialVerified) {
          this.pageErrorMessages.push({
            field: 'Cannot Export to CSV',
            detail: 'You are in customer trial mode. You can only export to CSV with paid subscription.',
            severity: 'error'
          });
        } else {
          this.pageErrorMessages.push({
            field: 'Failed to Export to CSV',
            detail: 'Failed to export donors data to CSV',
            severity: 'error'
          });
        }
        this.showPageErrorMessagesToUser(16000);
      });
    return true;
  }

  toggle(): boolean {
    if (!this.isSideNavOpened) {
      this.openNav();
    } else {
      this.closeNav();
    }
    return true;
  }
  openNav() {
    // @ts-ignore
    const element = document.getElementById("mySidenav");
    if (element) {
      element.style.width = "70%"
      // @ts-ignore
      element.style['padding-left'] = "20px";
      this.isSideNavOpened = true;
    }
  }

  /* Set the width of the side navigation to 0 */
  closeNav() {
    // @ts-ignore
    const element = document.getElementById("mySidenav");
    if (element) {
      element.style.width = "0";
      // @ts-ignore
      element.style['padding-left'] = "0px";
      this.isSideNavOpened = false;
    }
  }

  toggleCompanyNameAscButton(): void {
    this.companyNameAscRadioButton = !this.companyNameAscRadioButton;

    if (this.companyNameAscRadioButton && this.companyNameDescRadioButton) {
      this.companyNameAscRadioButton = true;
      this.companyNameDescRadioButton = false;
    }
  }

  toggleCompanyNameDescButton(): void {
    this.companyNameDescRadioButton = !this.companyNameDescRadioButton;
    if (this.companyNameAscRadioButton && this.companyNameDescRadioButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = true;
    }
  }

  toggleCityAscButton(): void {
    this.cityAscRadioButton = !this.cityAscRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = true;
      this.cityDescRadioButton = false;
    }
  }

  toggleCityDescButton(): void {
    this.cityDescRadioButton = !this.cityDescRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = true;
    }
  }

  toggleStateAscButton(): void {
    this.stateAscRadioButton = !this.stateAscRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = true;
      this.stateDescRadioButton = false;
    }
  }

  toggleStateDescButton(): void {
    this.stateDescRadioButton = !this.stateDescRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = true;
    }
  }

  toggleTotalAssetsAscButton(): void {
    this.totalAssetsAscRadioButton = !this.totalAssetsAscRadioButton;
    if (this.totalAssetsAscRadioButton && this.totalAssetsDescRadioButton) {
      this.totalAssetsAscRadioButton = true;
      this.totalAssetsDescRadioButton = false;
    }
  }

  toggleTotalAssetsDescButton(): void {
    this.totalAssetsDescRadioButton = !this.totalAssetsDescRadioButton;
    if (this.totalAssetsAscRadioButton && this.totalAssetsDescRadioButton) {
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = true;
    }
  }

  sortTextCompanyName(): void {
    if (!this.sortedAscCompanyNameHeaderButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = true;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    } else {
      this.companyNameAscRadioButton = true;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    }
    this.sortedAscCompanyNameHeaderButton = !this.sortedAscCompanyNameHeaderButton
    this.populateResultsFromLastSearch(true);
  }

  sortTextCity(): void {
    if (!this.sortedAscCityHeaderButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = true;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    } else {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = true;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    }
    this.sortedAscCityHeaderButton = !this.sortedAscCityHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  sortTextState(): void {
    if (!this.sortedAscStateHeaderButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = true;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    } else {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = true;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = false;
    }
    this.sortedAscStateHeaderButton = !this.sortedAscStateHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  sortNumberTotalAssets(): void {
    if (!this.sortedAscTotalAssetsHeaderButton) {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = false;
      this.totalAssetsDescRadioButton = true;
    } else {
      this.companyNameAscRadioButton = false;
      this.companyNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.totalAssetsAscRadioButton = true;
      this.totalAssetsDescRadioButton = false;
    }
    this.sortedAscTotalAssetsHeaderButton = !this.sortedAscTotalAssetsHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  formatZip(inputStr: string): string{
    return this.apiService.formatZipCode(inputStr)
  }
  formatEin(inputStr: string): string{
    return this.apiService.formatEin(inputStr)
  }

  onViewDetails(row: any) {
    const browserUrl = window.location.href;
    if (browserUrl.includes('donors')) {
      //For Donors
      this.routerChild.navigateByUrl(row.nonprofitDonorId ? `/app/search/donors/${row.nonprofitDonorId}/details` : 'home');
    } else {
      //Nonprofits
      this.routerChild.navigateByUrl(row.nonprofitDonorId ? `/app/search/nonprofits/${row.nonprofitDonorId}/details` : 'home');
    }
  }

  autocompleteCities() {

  }
}
